// removed by extract-text-webpack-plugin
module.exports = {"container":"SingleLine__container___LkTNU"};


/*****************
 ** WEBPACK FOOTER
 ** ./src/templates/SingleLine.less
 ** module id = 770
 ** module chunks = 0
 **/